import React from 'react';
import { Script } from 'gatsby';
import MuiWrapper from './muiwrapper';

const GTM_ID = 'GTM-NF3BFL3';

export const wrapRootElement = ({ element }) => {
  return (
    <MuiWrapper>
      {element}
      <Script
        id="gtm"
        strategy="off-main-thread"
        forward={['dataLayer.push', 'gtag']}
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){
              w[l]=w[l]||[];
              w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
              var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
              j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
              f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${GTM_ID}');
          `,
        }}
      />

      <Script id="affiliatly" src="https://static.affiliatly.com/v3/affiliatly.js?affiliatly_code=AF-1037030" strategy="off-main-thread" />

      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" title="google tag manager"
            height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      />
    </MuiWrapper>
  );
};

export const onClientEntry = () => {
  if (typeof window === 'undefined') return;

  const loadMautic = () => {
    if (window.MauticTrackingObject) return;

    (function (w, d, t, u, n, a, m) {
      w['MauticTrackingObject'] = n;
      w[n] =
        w[n] ||
        function () {
          (w[n].q = w[n].q || []).push(arguments);
        };
      a = d.createElement(t);
      m = d.getElementsByTagName(t)[0];
      a.async = 1;
      a.src = u;
      m.parentNode.insertBefore(a, m);
    })(window, document, 'script', 'https://m.paganidesignwatch.com/mtc.js', 'mt');

    const sendPageview = () => {
      if (typeof window.mt === 'function') {
        window.mt('send', 'pageview', { site_id: 'pagani', tags: 'pagani' });
      } else {
        window.addEventListener(
          'load',
          () => {
            if (typeof window.mt === 'function') {
              window.mt('send', 'pageview', { site_id: 'pagani', tags: 'pagani' });
            }
          },
          { once: true }
        );
      }
    };

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      sendPageview();
    } else {
      window.addEventListener('DOMContentLoaded', sendPageview, { once: true });
    }
  };

  const events = ['scroll', 'click', 'keydown', 'touchstart', 'mousemove'];
  const trigger = () => {
    setTimeout(() => {
      loadMautic();
    }, 3000);
    events.forEach((e) => window.removeEventListener(e, trigger, { passive: true }));
  };
  events.forEach((e) => window.addEventListener(e, trigger, { passive: true, once: true }));

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(loadMautic, { timeout: 10000 });
  } else {
    setTimeout(loadMautic, 10000);
  }
};
